/**
 * @flow
 * @relayHash b94d900e123978f8e409e61c1c93bae5
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type RelayRootContainerQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query RelayRootContainerQuery {
  viewer {
    ...IntlContainer_viewer
  }
}

fragment IntlContainer_viewer on Viewer {
  language
  ...RoutesContainer_viewer
}

fragment RoutesContainer_viewer on Viewer {
  ...Header_viewer
}

fragment Header_viewer on Viewer {
  email
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RelayRootContainerQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "viewer",
        "args": null,
        "concreteType": "Viewer",
        "name": "__viewer_viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "IntlContainer_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "RelayRootContainerQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "RelayRootContainerQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "language",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "args": null,
        "handle": "viewer",
        "name": "viewer",
        "key": "",
        "filters": null
      }
    ]
  },
  "text": "query RelayRootContainerQuery {\n  viewer {\n    ...IntlContainer_viewer\n  }\n}\n\nfragment IntlContainer_viewer on Viewer {\n  language\n  ...RoutesContainer_viewer\n}\n\nfragment RoutesContainer_viewer on Viewer {\n  ...Header_viewer\n}\n\nfragment Header_viewer on Viewer {\n  email\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/__generated__/RelayRootContainerQuery.graphql.js